import { useState } from "react";
import { Menu, X, Instagram } from "lucide-react";
import { SITE } from "../../data/content";

const links = [
  { id: "home", label: "Home" },
  { id: "cottages", label: "Cottages" },
  { id: "shepherds-huts", label: "Shepherd's Huts" },
  { id: "things-to-do", label: "Things To Do" },
  { id: "faqs", label: "FAQs" },
  { id: "contact", label: "Contact" },
];

export default function Navigation() {
  const [open, setOpen] = useState(false);

  const handleClick = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 glass-nav`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between py-5">
        <button
          data-testid="nav-logo"
          onClick={() => handleClick("home")}
          className="flex items-center gap-3 text-left"
        >
          <img
            src={SITE.logo}
            alt="Cheshire Holidays"
            className="h-11 w-11 sm:h-12 sm:w-12 object-cover"
            style={{ borderRadius: 2 }}
          />
          <span
            className="font-serif text-xl sm:text-2xl tracking-tight leading-none"
            style={{ color: "var(--dl-ink)", fontWeight: 500 }}
          >
            Cheshire Holidays
          </span>
        </button>

        <nav className="hidden lg:flex items-center gap-10">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => handleClick(l.id)}
              className="text-sm tracking-wide transition-colors hover:text-[color:var(--dl-accent)]"
              style={{ color: "var(--dl-ink)" }}
            >
              {l.label}
            </button>
          ))}
          <a
            data-testid="nav-instagram"
            href={SITE.instagram}
            target="_blank"
            rel="noreferrer"
            aria-label="Instagram"
            className="text-[color:var(--dl-ink)] hover:text-[color:var(--dl-accent)] transition-colors"
          >
            <Instagram size={18} />
          </a>
          <a
            data-testid="nav-reserve-btn"
            href={SITE.bookingExternal}
            target="_blank"
            rel="noreferrer"
            className="btn-primary"
          >
            Reserve Now
          </a>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          className="lg:hidden p-2 -mr-2"
          onClick={() => setOpen((v) => !v)}
          aria-label="Menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {/* Compact Reserve button visible only on mobile, next to hamburger area
          Slides into a dedicated slim strip so it's always tappable */}
      <div
        className="lg:hidden absolute top-1/2 -translate-y-1/2"
        style={{ right: "3.75rem" }}
        data-testid="nav-mobile-reserve-strip"
      >
        <a
          data-testid="nav-mobile-reserve-compact"
          href={SITE.bookingExternal}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center px-4 py-2 text-[0.65rem] tracking-[0.16em] uppercase font-medium"
          style={{
            background: "var(--dl-ink)",
            color: "var(--dl-bg)",
            borderRadius: 0,
          }}
        >
          Book
        </a>
      </div>

      {open && (
        <div data-testid="nav-mobile-drawer" className="lg:hidden mobile-drawer">
          <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col gap-1">
            {links.map((l) => (
              <button
                key={l.id}
                data-testid={`nav-mobile-link-${l.id}`}
                onClick={() => handleClick(l.id)}
                className="text-left py-3 text-base border-b"
                style={{ borderColor: "var(--dl-border)", color: "var(--dl-ink)" }}
              >
                {l.label}
              </button>
            ))}
            <div className="flex items-center gap-4 pt-5">
              <a
                data-testid="nav-mobile-reserve-btn"
                href={SITE.bookingExternal}
                target="_blank"
                rel="noreferrer"
                className="btn-primary"
              >
                Reserve Now
              </a>
              <a
                href={SITE.instagram}
                target="_blank"
                rel="noreferrer"
                className="text-[color:var(--dl-ink)]"
                aria-label="Instagram"
              >
                <Instagram size={20} />
              </a>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
